import { FunctionComponent, ReactNode } from 'react';

import DropDownIndicator from '../../Atomic/DropDownIndicator/DropDownIndicator';

import styles from './NavTop.module.scss';

export type NavTopProps = {
  label?: string;
  children?: ReactNode;
};

type FC = FunctionComponent<NavTopProps>;

const NavTop: FC = ({ label, children }: NavTopProps) => (
  <div className={styles.container}>
    <DropDownIndicator label={label} float="left" showAngleDown={false} showPointer={false} />
    {children}
  </div>
);

export default NavTop;
